import translationTypes from '../actionTypes/language';

const initialStore = {
  language: 'en-US',
  languageList: [],
  translations: {},
  languageIsLoading: false,
};

const reducer = (state = initialStore, { type, payload }) => {
  switch (type) {
    case translationTypes.GET_LANGUAGE_START:
      return {
        ...state,
        languageIsLoading: true,
      };
    case translationTypes.GET_LANGUAGE_SUCCESS:
      return {
        ...state,
        languageList: payload,
        languageIsLoading: false,
      };
    case translationTypes.GET_LANGUAGE_FAIL:
      return {
        ...state,
        languageIsLoading: false,
      };
    case translationTypes.GET_TRANSLATIONS_START:
      return {
        ...state,
        languageIsLoading: true,
      };
    case translationTypes.GET_TRANSLATIONS_SUCCESS:
      return {
        ...state,
        translations: payload,
        languageIsLoading: false,
      };
    case translationTypes.GET_TRANSLATIONS_FAIL:
      return {
        ...state,
        languageIsLoading: false,
      };
    case translationTypes.SET_LANGUAGE:
      return {
        ...state,
        language: payload,
      };
    default:
      return state;
  }
};

export default reducer;
